import { combineReducers } from "redux";
import user from "./user.reducer";
import login from "./login.reducer";
import checkToken from "./checkToken.reducer";
import updateUser from "./updateUser.reducer";

const authReducer = combineReducers({
  user,
  login,
  checkToken,
  updateUser,
});

export default authReducer;
